import React from "react";

export function AgentAvatar() {
    const gradientId = `${React.useId().replace(/:/g, "")}-agent-avatar-paint`;

    return (
        <svg
            width="27px"
            height="27px"
            viewBox="0 0 68 68"
            fill="none"
            style={{ display: "block" }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="67.9994"
                height="67.6585"
                rx="33.8293"
                fill={`url(#${gradientId})`}
            />
            <path
                d="M43.298 49.0078C44.267 47.9045 45.9476 47.7957 47.0509 48.7646C47.9632 49.5658 48.1929 50.852 47.6984 51.8975C44.6122 54.2423 40.9077 55.8148 36.8713 56.3252L43.298 49.0078ZM31.5051 47.5918C32.4741 46.4884 34.1546 46.3786 35.258 47.3477C36.3614 48.3167 36.4701 49.9972 35.5011 51.1006L30.9347 56.2988C28.9364 56.0287 27.0206 55.4998 25.2228 54.7441L31.5051 47.5918ZM28.5773 36.0801C29.5463 34.9767 31.2259 34.8679 32.3293 35.8369C33.4326 36.8059 33.5414 38.4855 32.5724 39.5889L21.1945 52.5439C19.726 51.5366 18.382 50.3613 17.1906 49.0449L28.5773 36.0801ZM56.6662 33.8398C56.6662 38.0712 55.5041 42.0306 53.4855 45.4199C52.4968 46.2673 51.0129 46.2844 50.006 45.4004C48.9026 44.4314 48.7938 42.7509 49.7629 41.6475L56.6652 33.7871C56.6652 33.8047 56.6662 33.8223 56.6662 33.8398ZM16.2297 35.2939C17.1987 34.1905 18.8792 34.0818 19.9826 35.0508C21.0856 36.0198 21.1945 37.6994 20.2258 38.8027L14.4718 45.3535C13.4781 43.6717 12.6964 41.8502 12.1613 39.9258L16.2297 35.2939ZM53.5929 22.4395C54.5797 24.1317 55.353 25.9631 55.8771 27.8975L41.965 43.7402C40.996 44.8432 39.3164 44.952 38.2131 43.9834C37.1097 43.0144 37 41.3339 37.9689 40.2305L53.5929 22.4395ZM11.3361 34.0791C11.3353 33.9995 11.3332 33.9196 11.3332 33.8398C11.3333 22.2313 20.0605 12.6624 31.3117 11.333L11.3361 34.0791ZM46.9064 15.207C48.3695 16.2224 49.7072 17.4052 50.8918 18.7285L39.0373 32.2285C38.0682 33.3319 36.3877 33.4407 35.2843 32.4717C34.1811 31.5026 34.0722 29.8221 35.0412 28.7188L46.9064 15.207ZM37.2121 11.4004C39.2015 11.6827 41.1075 12.2235 42.8957 12.9873L26.6896 31.4424C25.7206 32.5456 24.041 32.6544 22.9377 31.6855C21.8344 30.7167 21.725 29.037 22.6935 27.9336L37.2121 11.4004Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="2.01693"
                    y1="2.67487"
                    x2="71.8898"
                    y2="63.9346"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="1.0001" stopColor="#3364D6" />
                </linearGradient>
            </defs>
        </svg>
    );
}
